(ns frontend.ux-overhaul.listing.sales-opportunity.view
  (:require [frontend.state.current-session :as session]))

(def config
  {:listing-id               "sales-opportunity-listing"
   :entity-type              :entity.type/sales-opportunity
   :route-id                 :sales-opportunities-grid
   :create-action-id         :create-sales-opportunity
   :create-label             :sales-opportunity-add-button
   :pipeline-attribute       :sales-opportunity/pipeline
   :pipeline-key             :sales-opportunity-pipeline
   :module                   :module/sales-pipelines
   :route-with-pipeline-id   :sales-opportunities-grid-with-pipeline
   :stage-entity-type        :entity.type/sales-opportunity-stage
   :stage-name-attribute     :sales-opportunity-stage/name
   :stage-pipeline-attribute :sales-opportunity-stage/pipeline
   :title                    :sales-opportunities
   :selected-pipeline        session/selected-sales-oppo-pipeline
   :all-pipelines            session/all-sales-oppo-pipelines
   :feature?                 session/sales-pipelines?})
